import axios from "axios";

const BASE_URL = `/m-1/attachments`;

/**
 * Serwis do komunikacji z API - endpoint /attachments
 */
export const AttachmentsService = {
  getClientAttachmentsByToken,
  getAttachment,
  createAttachment,
  deleteAttachment,
  downloadAttachment,
};

function getClientAttachmentsByToken() {
  return axios.get(`${BASE_URL}`);
}

function getAttachment(id) {
  return axios.get(`${BASE_URL}/${id}`);
}

function createAttachment(file) {
  return axios.post(`${BASE_URL}`, file);
}

function deleteAttachment(id) {
  return axios.delete(`${BASE_URL}/${id}`);
}

function downloadAttachment(id) {
  return axios.get(`${BASE_URL}/${id}/file`, {
    responseType: "blob",
  });
}
